import fr from 'facet-rest';
import { navigateToPage, buildClientLink, buildAdvisorLink } from 'Views/Page/Content/Templates';
import throwInDevOutsideReact from 'Helpers/throwInDevOutsideReact';
import { FORCE_FOCUS_MODE_QUERY_PARAM } from 'Context/LayoutContext';

export function openURLInNewTab(url, windowFeatures = 'noopener,noreferrer') {
  window.open(url, '_blank', windowFeatures);
}

export function navigateLinkToAgentPage(link, openInNewTab = false) {
  if (openInNewTab) {
    openURLInNewTab(buildAdvisorLink(link));
    return;
  }

  navigateToPage(link, true);
}

export function navigateLinkToClientPage(link, openInNewTab = false) {
  if (openInNewTab) {
    openURLInNewTab(buildClientLink(link));
    return;
  }

  navigateToPage(link, false);
}

export async function goToAccountOpeningFlow(resource, openInNewTab = false) {
  const [accountOpeningStep] = await resource?.relationship(fr.relationships.accountOpeningWizard.name)?.link('related').get();
  const link = accountOpeningStep.link('self');

  navigateLinkToClientPage(link, openInNewTab);
}

export async function goToAccountRetitlingFlow(resource, openInNewTab = false) {
  const [accountRetitlingStep] = await resource?.relationship(fr.relationships.accountRetitlingWizard.name)?.link('related').get();
  const link = accountRetitlingStep.link('self');

  navigateLinkToClientPage(link, openInNewTab);
}

export const navigateToUriInNewTab = (e, uri, windowFeatures = 'noopener,noreferrer') => {
  e.preventDefault();
  openURLInNewTab(uri, windowFeatures);
};

export const makeLinkOpenInFocusMode = (url) => {
  if (!url) {
    return throwInDevOutsideReact("Can't call makeLinkOpenInFocusMode without any input") ?? url;
  }
  if (url instanceof URL) {
    url.searchParams.set(FORCE_FOCUS_MODE_QUERY_PARAM, 'true');
    return url;
  }
  if (typeof url === 'string') {
    // This "url" may not be a real URL, it may just be like /foo instead of like https://app.facetwealth.com/foo
    // If it's not a complete URL, we need to complete it (using the URL bar's origin) to be able to call the URL constructor on it
    const isCompleteURL = !url.startsWith('/');
    const { origin } = new URL(window.location.toString());
    const oldURL = isCompleteURL ? url : origin + url;
    // Now we can actually change it
    const newURL = makeLinkOpenInFocusMode(new URL(oldURL));
    // If it wasn't a complete URL to begin with, then let's provide output that matches
    if (!isCompleteURL) {
      return newURL.pathname + newURL.search + newURL.hash;
    }
    return newURL.toString();
  }
  return throwInDevOutsideReact("Can't call makeLinkOpenInFocusMode with invalid input") ?? url;
};
